angular.module('hal-common').directive('halGenerator', function () {
  return {
    scope: {
      value: '=',
      card: '=',
      inApp: '=',
      onComplete: '&',
      onCancel: '&',
      resetGenerator: '=',
      inGenerator: '=',
    },
    templateUrl: '/templates/hal-common/directives/generator.html',
    controller: [
      '$rootScope',
      '$scope',
      'UserService',
      'HALResource',
      '$timeout',
      'toaster',
      '$filter',
      '$state',
      '$modal',
      function ($rootScope, $scope, UserService, HALResource, $timeout, toaster, $filter, $state, $modal) {
        $scope.userLoading = true;
        $scope.UserService = UserService;
        $scope.base_asset_url = $rootScope.base_asset_url;

        $scope.customSelection = false;
        $scope.lastQuery = false;
        $scope.imagesLoading = false;
        $scope.availableImages = [];
        $scope.finishing = false;
        $scope.definition = '';
        $scope.offset = 0;

        $scope.$watch('resetGenerator', function (newVal, oldVal) {
          if (newVal) {
            $scope.reset();
          }
        });

        if (typeof atlasEvent !== 'undefined') {
          atlasEvent('HAL', 'Generate Character Click');
        }

        var globalZ = 1;

        var resize = function () {
          var editor = angular.element('#hal_character_editor');
          var ratio = editor.width() / 2200;
          var new_height = ratio * 1700;
          editor.height(new_height);

          var word_container = angular.element('#hal_word_container');
          if (angular.element(window).width() < 991) {
            var new_height = angular.element(window).height() - new_height - 260;
            word_container.height(new_height);
          } else {
            word_container.height('100%');
          }
        };
        angular.element(window).on('resize', resize);

        $scope.selection = { bounding: [0, $scope.value.length - 1] };

        $scope.playerService = {
          addToHistory: function () {},
          assetStatus: [],
          hasAccess: function () {
            return true;
          },
          selectCharacter: function (character) {
            return $scope.selectCharacter(character);
          },
          currentFacts: $scope.facts,
          mode: 'editor',
        };

        if (UserService.user && UserService.user.$promise) {
          UserService.user.$promise.then(function () {
            $scope.userLoading = false;
            resize();
            if (!$scope.recommendationsLoading) {
              $scope.initialLoading = false;
            }
          });
        } else {
          $scope.userLoading = false;
          resize();
        }

        $scope.continue = function () {
          if ($scope.step == 'word' || $scope.step == 'finish') {
            if ($scope.selected.word) {
              $scope.selected.words.push($scope.selected.word);
              $scope.selected.current_words.push($scope.selected.word);
              $scope.loadImages();
              $scope.step = 'image';
            } else {
              toaster.error('You must choose a word before continuing.');
            }
          } else if ($scope.step == 'image') {
            $scope.step = 'finish';
            $scope.lastQuery = false;
            if ($scope.selected.image) {
              $scope.selected.images.push($scope.selected.image);
            } else {
              $scope.selected.images.push(false);
            }
            $scope.selected.word = false;
            $scope.selected.syllables = false;
            $scope.selected.image = false;
            $scope.pagination.page = 1;
            $scope.search();
          } else if ($scope.step == 'finish') {
            $scope.step = 'word';
          }
        };

        $scope.editQuery = function (status) {
          $scope.editingQuery = status !== false;
          if ($scope.editingQuery) {
            $timeout(function () {
              angular.element('#hal-query-input').focus();
            }, 0);
          } else if (!$scope.editingQuery && $scope.lastQuery != $scope.request.query) {
            $scope.pagination.page = 1;
            $scope.search();
          }
        };

        $scope.finish = function () {
          if (typeof atlasEvent !== 'undefined') {
            atlasEvent('HAL', 'Finish Click');
          }
          // Build the blue-word
          var blue_word = [];
          angular.forEach($scope.selected.words, function (ruleset_word) {
            blue_word.push($filter('ucfirst')(ruleset_word.word));
          });
          blue_word = blue_word.join('-');

          var valid_facts = [];
          angular.forEach($scope.facts, function (fact) {
            if (fact && fact.characters.length) {
              valid_facts.push(fact);
            }
          });

          if (valid_facts.length) {
            var characters = [];
            var max_width = 0;
            var max_height = 0;
            var has_primary = false;
            var min_x = 999;
            var min_y = 999;
            angular.forEach($scope.facts, function (fact) {
              if (fact.characters[0]) {
                angular.forEach(fact.characters[0].assets, function (asset) {
                  characters.push(Object.assign({}, fact.characters[0], asset));

                  asset.x = fact.characters[0].character_x + fact.characters[0].crop_x;
                  asset.y = fact.characters[0].character_y + fact.characters[0].crop_y;
                  asset.z = fact.characters[0].character_z;

                  asset.width *= fact.characters[0].crop_width / fact.characters[0].original_width;
                  asset.height *= fact.characters[0].crop_height / fact.characters[0].original_height;

                  if (asset.x < min_x) {
                    min_x = asset.x;
                  }
                  if (asset.y < min_y) {
                    min_y = asset.y;
                  }

                  // Adjust the width & height of the character
                  if (parseInt(asset.x) + parseInt(asset.width) > max_width) {
                    max_width = parseInt(asset.width) + parseInt(asset.x);
                  }
                  if (parseInt(asset.y) + parseInt(asset.height) > max_height) {
                    max_height = parseInt(asset.height) + parseInt(asset.y);
                  }
                });
              }
            });

            //Adjust x & y
            angular.forEach(characters, function (character) {
              character.character_x -= min_x;
              character.character_y -= min_y;
            });

            // Generate a mnemonic entry from the character
            $scope.finishing = true;
            HALResource.generator.store(
              {
                characters: characters,
                fact: { name: $scope.value, picmonic: blue_word },
                generator: $scope.inGenerator ? true : false,
                description: $scope.selected.description,
                size: {
                  x: min_x,
                  y: min_y,
                  width: max_width - min_x,
                  height: max_height - min_y,
                },
              },
              function (mnemonic) {
                if ($scope.onComplete) {
                  if (!$scope.inGenerator) {
                    // Return the character as-is
                    $scope.onComplete({ $character: mnemonic });
                    $scope.finishing = false;
                  } else {
                    // Build the character from the mnemonic
                    var multiplier = mnemonic.width > 2200 ? mnemonic.width / 2200 : 1;
                    var new_character = {
                      name: blue_word,
                      character_width: mnemonic.width * multiplier,
                      character_height: mnemonic.height * multiplier,
                      original_width: mnemonic.width,
                      original_height: mnemonic.height,
                      character_x: 0,
                      character_y: 0,
                      mirrored_x: 0,
                      mirrored_y: 0,
                      hal: true,
                      assets: [
                        {
                          name: blue_word,
                          x: 0,
                          y: 0,
                          z: 0,
                          is_primary: 1,
                          width: mnemonic.width * multiplier,
                          height: mnemonic.height * multiplier,
                          image_url: mnemonic.image_url,
                        },
                      ],
                    };
                    $scope.onComplete({ $character: new_character });
                    $scope.finishing = false;
                  }
                }
              }
            );
          }

          // TODO: Alert the user of the need for valid facts
          return false;
        };

        $scope.loadImages = function () {
          $scope.imagesLoading = true;
          HALResource.images.get(
            {
              word_id: $scope.selected.word.word_id,
              page: $scope.image_page,
            },
            function (res) {
              $scope.imagesLoading = false;
              $scope.availableImages = res.data.data;
            }
          );
        };

        $scope.loadMoreImages = function () {
          $scope.image_page++;
        };

        $scope.loadMoreWords = function (syllables) {
          $scope.pagination.page++;
          $scope.search(true, syllables);
        };

        $scope.onSelectionChange = function (text) {
          if (typeof atlasEvent !== 'undefined') {
            atlasEvent('HAL', 'Show More Results');
          }
          $scope.selected.current_words = [];
          $scope.customSelection = true;
          $scope.request.query = text;
          $scope.lastQuery = false;
          $scope.pagination.page = 1;
          $scope.search();
        };

        $scope.removeWord = function (index) {
          var word = $scope.selected.words[index];
          var offset = $scope.offsets[index];
          $scope.selected.current_words.splice(
            index - ($scope.selected.words.length - $scope.selected.current_words.length)
          );
          $scope.selected.words.splice(index);
          $scope.selected.images.splice(index);
          $scope.offsets.splice(index);
          $scope.selection.bounding[0] = offset;
          $scope.facts.splice(index);
          $scope.step = 'word';
          $scope.recommendations = [];
          if (!$scope.selected.words.length) {
            $scope.initialLoading = true;
          }
          $scope.selected.word = false;
          $scope.selected.syllables = false;
          $scope.selected.image = false;
          $scope.pagination.page = 1;
          $scope.image_page = 1;
          $scope.search();
        };

        $scope.removeImage = function (index) {
          if ($scope.offsets.length > index + 1) {
            $scope.selection.bounding[0] = $scope.offsets[index + 1];
            $scope.offsets.splice(index + 1);
          }
          $scope.selected.current_words.splice(
            index + 1 - ($scope.selected.words.length - $scope.selected.current_words.length)
          );
          $scope.selected.words.splice(index + 1);
          $scope.selected.word = $scope.selected.words[index];
          $scope.selected.syllables =
            $scope.selected.words[index].syllables > 4 ? 4 : $scope.selected.words[index].syllables;
          $scope.selected.images.splice(index);
          $scope.facts.splice(index);
          $scope.step = 'image';
          if (!$scope.selected.words.length) {
            $scope.initialLoading = true;
          }
          $scope.pagination.page = 1;
          $scope.image_page = 1;
          $scope.loadImages();
        };

        $scope.close = function () {
          //EditorService.halOpen = false;
        };

        $scope.search = function (append, syllables) {
          append = append === true;
          syllables = syllables || false;
          $scope.recommendationsLoading = syllables;

          // Expose selected words and values
          var request_data = {
            selected_words: [],
            selected_values: [],
            syllables: syllables,
          };

          if ($scope.selected.current_words.length) {
            angular.forEach($scope.selected.current_words, function (ruleset_word) {
              request_data.selected_words.push(ruleset_word.word);
              request_data.selected_values.push(ruleset_word.value);
            });
          }
          if ($scope.customSelection) {
            $scope.lastQuery = false;
            $scope.request.query = $scope.value;
            //request_data.offset =
            $scope.offset = $scope.selection.bounding[0];
          }

          $scope.request.query = $scope.request.query.substr($scope.offset);

          //request_data.offset = $scope.offset;
          request_data.selected_words = angular.toJson(request_data.selected_words);
          request_data.selected_values = angular.toJson(request_data.selected_values);
          request_data.page = $scope.pagination.page;
          $scope.request.original_query = $scope.value.toLowerCase().substr($scope.offset);
          Object.assign(request_data, $scope.request);
          HALResource.search.query(request_data, function (res) {
            if (res.query != $scope.request.original_query) {
              // If we had a custom selection, ignore the offset
            } else {
              // Otherwise set the offset
              var offset = parseInt(res.match_offset) + $scope.offset;
              $scope.selection.bounding[0] = offset;
              $scope.selection.bounding[1] = $scope.value.length;
            }
            // Reset the query
            $scope.request.query = $scope.value;
            $scope.lastQuery = $scope.value;
            $scope.pagination.last_page = res.last_page;
            $scope.pagination.total = res.total;
            if (append) {
              for (var x in res.data) {
                if (!$scope.recommendations.hasOwnProperty(x)) {
                  $scope.recommendations[x] = [];
                }
                $scope.recommendations[x] = $scope.recommendations[x].concat(res.data[x]);
              }
            } else {
              $scope.recommendations = res.data;
            }
            $scope.recommendationsLoading = false;
            if (!$scope.userLoading) {
              $scope.initialLoading = false;
            }
          });
          $scope.customSelection = false;
        };

        $scope.selectCharacter = function (character) {
          angular.forEach($scope.facts, function (fact) {
            if (fact.characters[0]) {
              fact.characters[0].selected = false;
            }
          });
          character.selected = true;
        };

        $scope.selectWord = function (word, syllables) {
          $scope.offsets.push($scope.selection.bounding[0]);
          $scope.selected.word = word;
          $scope.selected.syllables = syllables;
          $scope.continue();
        };

        $scope.selectImage = function (image) {
          var asset = {};
          Object.assign(asset, image);
          asset.width = parseInt(asset.width);
          asset.height = parseInt(asset.height);

          // Place character in the center
          char_x = 2200 / 2 - asset.width / 2;
          char_y = 1700 / 2 - asset.height / 2;

          if (char_x + asset.width > 2200 || char_x < 0) {
            char_x = 0;
          }

          if (char_y + asset.height > 1700 || char_y < 0) {
            char_y = 0;
          }

          // Add the asset to the character
          var fact = {
            characters: [
              {
                character_z: globalZ,
                character_x: char_x,
                character_y: char_y,
                crop_x: 0,
                crop_y: 0,
                crop_height: asset.height,
                crop_width: asset.width,
                x: char_x,
                y: char_y,
                z: globalZ,
                is_primary: !$scope.selected.images.length,
                character_width: asset.width,
                original_width: asset.width,
                character_height: asset.height,
                original_height: asset.height,
                hotspot_x: 0,
                hotspot_y: 0,
                assets: [],
              },
            ],
          };
          asset.x = 0;
          asset.y = 0;
          asset.z = 0;
          fact.characters[0].assets.push(asset);
          fact.characters[0].selected = true;
          $scope.facts.push(fact);

          globalZ++;

          $scope.selected.image = image;
          $scope.selected.images.push(image);
          $scope.continue();
        };

        $scope.setStep = function (step) {
          $scope.step = step;
        };

        $scope.reset = function (preventRedirect) {
          if (typeof atlasEvent !== 'undefined' && !$scope.initialLoading) {
            atlasEvent('HAL', 'Start Over Click');
          }

          if (
            !preventRedirect &&
            $scope.selected.words.length &&
            !confirm('You haven’t saved your creation yet! Are you sure you want to create new')
          ) {
            return;
          }

          if (!preventRedirect && $scope.inApp) {
            $state.go('hal.index', {}, { reload: true });
          } else {
            $scope.request = {
              query: $scope.value + '',
              per_page: 4,
              with_images: true,
            };

            // Reset selection
            $scope.selection = { bounding: [0, $scope.value.length - 1] };

            $scope.pagination = {
              last_page: 1,
              page: 1,
              total: 1,
            };

            $scope.selected = {
              word: false,
              image: false,
              words: [],
              current_words: [],
              images: [],
              syllables: false,
            };
            $scope.offsets = [];
            $scope.facts = [];

            $scope.image_page = 1;
            $scope.images_per_page = 6;

            $scope.initialLoading = true;
            $scope.recommendationsLoading = true;
            $scope.lastQuery = false;
            $scope.editingQuery = false;
            $scope.step = 'word';
            $scope.selection[0] = 0;
            $scope.selection[1] = $scope.value.length - 1;

            $scope.initialLoading = true;
            $scope.recommendationsLoading = true;
            $scope.lastQuery = false;
            $scope.editingQuery = false;
            $scope.step = 'word';
            $scope.selection[0] = 0;
            $scope.selection[1] = $scope.value.length - 1;

            $scope.playerService.currentFacts = $scope.facts;
            $scope.pagination.page = 1;
            $scope.search();
            //$scope.resetGenerator = false;
          }
        };

        $scope.reset(true, true);

        $scope.cancel = function () {
          if ($scope.onCancel) {
            $scope.onCancel();
          }
        };

        $scope.$on('$destroy', function () {
          if (typeof atlasEvent !== 'undefined') {
            atlasEvent('HAL', 'Hal Closed');
          }
        });

        $scope.preview = function () {
          $modal.open({
            templateUrl: '/templates/hal-common/modals/preview.html',
            scope: $scope,
            controller: [
              '$scope',
              '$filter',
              function ($scope, $filter) {
                $scope.character = $scope.$parent.selected.words
                  .map(function (value) {
                    return $filter('ucfirst')(value.word);
                  })
                  .join('-');
                var playerService = angular.copy($scope.$parent.playerService);
                playerService.mode = 'learn';
                $scope.playerService = playerService;
              },
            ],
          });
        };
      },
    ],
  };
});
